import { useState } from "react";

const dealers = ["Teknoloji Dünyası", "Bilgisayar Plaza", "Ofis Market", "Ana Bayi", "Elektronik Merkezi"];
const warehouses = ["Ana Depo", "İstanbul Şube", "İzmir Şube", "Ankara Şube"];

const allData = [
  { category: "Elektronik", saleQty: 245, saleAmount: 185000, purchaseAmount: 112000, profit: 73000, margin: 39.5, topProduct: "27\" Monitör" },
  { category: "Aksesuar", saleQty: 178, saleAmount: 68000, purchaseAmount: 38500, profit: 29500, margin: 43.4, topProduct: "USB-C Hub" },
  { category: "Ofis", saleQty: 320, saleAmount: 42000, purchaseAmount: 24500, profit: 17500, margin: 41.7, topProduct: "Masa Lambası LED" },
  { category: "Giyim", saleQty: 85, saleAmount: 24000, purchaseAmount: 15200, profit: 8800, margin: 36.7, topProduct: "Notebook Çantası" },
];

export default function CategoryBasedSalesReport() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dealer, setDealer] = useState("");
  const [warehouse, setWarehouse] = useState("");

  const data = allData;

  const totalSales = data.reduce((s, d) => s + d.saleAmount, 0);
  const totalProfit = data.reduce((s, d) => s + d.profit, 0);

  const pieData = data.map((d) => ({ label: d.category, value: d.saleAmount, color: d.category === "Elektronik" ? "bg-primary-400" : d.category === "Aksesuar" ? "bg-accent-400" : d.category === "Ofis" ? "bg-secondary-400" : "bg-foreground-400" }));
  const maxVal = Math.max(...pieData.map((d) => d.value));

  return (
    <div className="space-y-4">
      <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <div className="bg-accent-800 px-4 py-3 flex items-center justify-between">
          <span className="text-sm font-semibold text-background-50">Kategori Bazlı Satış Rapor Kriterleri</span>
          <button onClick={() => { setStartDate(""); setEndDate(""); setDealer(""); setWarehouse(""); }} className="text-xs text-background-50/80 hover:text-background-50 transition-colors cursor-pointer">Temizle</button>
        </div>
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="sm:col-span-2">
            <label className="block text-xs font-medium text-foreground-600 mb-1">Tarih Aralığı</label>
            <div className="flex items-center gap-2">
              <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400" />
              <span className="text-sm text-foreground-400">-</span>
              <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Cari Bayi</label>
            <select value={dealer} onChange={(e) => setDealer(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400 cursor-pointer">
              <option value="">Tümü</option>
              {dealers.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Depo</label>
            <select value={warehouse} onChange={(e) => setWarehouse(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-accent-400 cursor-pointer">
              <option value="">Tümü</option>
              {warehouses.map((w) => <option key={w} value={w}>{w}</option>)}
            </select>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
          <p className="text-xs text-foreground-400 mb-1">Toplam Satış</p>
          <p className="text-xl font-bold text-foreground-950">${totalSales.toLocaleString("en-US")}</p>
        </div>
        <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
          <p className="text-xs text-foreground-400 mb-1">Toplam Kâr</p>
          <p className="text-xl font-bold text-primary-600">${totalProfit.toLocaleString("en-US")}</p>
        </div>
      </div>

      <div className="bg-background-50 border border-background-200/70 rounded-xl p-4">
        <h3 className="text-sm font-semibold text-foreground-950 mb-4">Kategori Dağılımı</h3>
        <div className="flex items-end justify-around gap-3 h-40">
          {pieData.map((item, i) => (
            <div key={i} className="flex flex-col items-center gap-1 flex-1">
              <span className="text-xs font-medium text-foreground-700">${(item.value / 1000).toFixed(0)}K</span>
              <div className={`w-12 ${item.color} rounded-t-lg`} style={{ height: `${(item.value / maxVal) * 120}px` }}></div>
              <span className="text-[10px] text-foreground-400">{item.label}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-foreground-950">Kategori Bazlı Satışlar</h2>
        <span className="text-sm text-foreground-500">{data.length} kategori</span>
      </div>

      <div className="hidden lg:block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-background-100 border-b border-background-200/70">
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Kategori</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Satış Adet</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Satış Tutarı</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Maliyet</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Kâr</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Marj %</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">En Çok Satan</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr key={idx} className="border-b border-background-200/50 hover:bg-background-100/50 transition-colors">
                <td className="px-4 py-3 font-medium text-foreground-900">{item.category}</td>
                <td className="px-4 py-3 text-center text-foreground-900">{item.saleQty}</td>
                <td className="px-4 py-3 text-right font-semibold text-foreground-900">${item.saleAmount.toLocaleString("en-US")}</td>
                <td className="px-4 py-3 text-right text-foreground-500">${item.purchaseAmount.toLocaleString("en-US")}</td>
                <td className="px-4 py-3 text-right font-semibold text-primary-600">${item.profit.toLocaleString("en-US")}</td>
                <td className="px-4 py-3 text-right text-foreground-500">%{item.margin.toFixed(1)}</td>
                <td className="px-4 py-3 text-foreground-500">{item.topProduct}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="lg:hidden space-y-3">
        {data.map((item, idx) => (
          <div key={idx} className="bg-background-50 border border-background-200/70 rounded-xl p-4">
            <div className="flex items-center justify-between">
              <p className="text-sm font-medium text-foreground-900">{item.category}</p>
              <p className="text-sm font-bold text-foreground-900">${item.saleAmount.toLocaleString("en-US")}</p>
            </div>
            <p className="text-xs text-foreground-400 mt-1">{item.saleQty} adet · Kâr: ${item.profit.toLocaleString("en-US")} · Marj: %{item.margin.toFixed(1)}</p>
            <p className="text-xs text-foreground-500 mt-1">En çok satan: {item.topProduct}</p>
          </div>
        ))}
      </div>
    </div>
  );
}